export var list = [
    'netWorth',
    'monthlyExpenses',
    'monthlyIncome',
    'cash',
    'owner',
];
